import { Injectable } from '@angular/core';
import { CanDeactivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmDialogService } from '../app/features/confirm-dialog/confirm-dialog.service';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard
  implements CanDeactivate<CanComponentDeactivate>
{
  constructor(private confirmDialog: ConfirmDialogService) {}

  canDeactivate(
    component: CanComponentDeactivate
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (component.canDeactivate) {
      return component.canDeactivate();
    }
    return true;
  }
}
